const e=(...e)=>{const t=e.reduce(((e,t)=>({...e,...t})),{});if(!t||0!==Object.keys(t).length)return t};export{e as default};
//# sourceMappingURL=mergeMessages.js.map
